import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setStoredSelectedPlanId } from '../selectedPlanStorage';

export const usePersistPlanFromQuery = () => {
	const [searchParams] = useSearchParams();
	const planoParam = searchParams.get('plano');

	useEffect(() => {
		if (planoParam) {
			setStoredSelectedPlanId(planoParam);
		}
	}, [planoParam]);
};
